import Dexie, { type EntityTable } from "dexie";
import type {
  Account,
  AlertRule,
  AppPreference,
  FxPoint,
  InstrumentEnrichment,
  JournalEntry,
  MigrationRecord,
  Portfolio,
  PricePoint,
  Security,
  StoredQuote,
  TargetAllocation,
  Transaction,
  Watchlist,
  WatchlistItem
} from "../domain/types";

export class CherryDatabase extends Dexie {
  portfolios!: EntityTable<Portfolio, "id">;
  accounts!: EntityTable<Account, "id">;
  securities!: EntityTable<Security, "id">;
  transactions!: EntityTable<Transaction, "id">;
  pricePoints!: EntityTable<PricePoint, "id">;
  fxPoints!: EntityTable<FxPoint, "id">;
  instrumentEnrichments!: EntityTable<InstrumentEnrichment, "id">;
  quotes!: EntityTable<StoredQuote, "symbol">;
  targetAllocations!: EntityTable<TargetAllocation, "id">;
  watchlists!: EntityTable<Watchlist, "id">;
  watchlistItems!: EntityTable<WatchlistItem, "id">;
  alertRules!: EntityTable<AlertRule, "id">;
  journalEntries!: EntityTable<JournalEntry, "id">;
  migrationRecords!: EntityTable<MigrationRecord, "id">;
  preferences!: EntityTable<AppPreference, "key">;

  constructor(name = "cherry-terminal-v1") {
    super(name);
    this.version(1).stores({
      portfolios: "id, name, updatedAt",
      accounts: "id, portfolioId, [portfolioId+name]",
      securities: "id, &yahooSymbol, currency, type",
      transactions: "id, portfolioId, accountId, securityId, tradeDate, type, importFingerprint, [portfolioId+tradeDate]",
      pricePoints: "id, securityId, date, [securityId+date]",
      fxPoints: "id, [baseCurrency+quoteCurrency], date, [baseCurrency+quoteCurrency+date]",
      quotes: "&symbol, securityId, asOf, status",
      targetAllocations: "id, portfolioId, dimension, [portfolioId+dimension]",
      watchlists: "id, portfolioId",
      watchlistItems: "id, watchlistId, securityId, nextReviewDate",
      alertRules: "id, portfolioId, kind, securityId",
      journalEntries: "id, portfolioId, securityId, nextReviewDate",
      migrationRecords: "id, version, migratedAt",
      preferences: "key"
    });
    this.version(2).stores({
      portfolios: "id, name, updatedAt",
      accounts: "id, portfolioId, [portfolioId+name]",
      securities: "id, &yahooSymbol, currency, type",
      transactions: "id, portfolioId, accountId, securityId, tradeDate, type, importFingerprint, [portfolioId+tradeDate]",
      pricePoints: "id, securityId, date, [securityId+date]",
      fxPoints: "id, [baseCurrency+quoteCurrency], date, [baseCurrency+quoteCurrency+date]",
      quotes: "&symbol, securityId, asOf, status",
      instrumentEnrichments: "id, &symbol, fetchedAt, expiresAt",
      targetAllocations: "id, portfolioId, dimension, [portfolioId+dimension]",
      watchlists: "id, portfolioId",
      watchlistItems: "id, watchlistId, securityId, nextReviewDate",
      alertRules: "id, portfolioId, kind, securityId",
      journalEntries: "id, portfolioId, securityId, nextReviewDate",
      migrationRecords: "id, version, migratedAt",
      preferences: "key"
    });
  }
}

export const db = new CherryDatabase();
